import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@material-ui/core';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons';
import * as Styled from './styled';
import { RootStoreContext } from '../../App';

export const TimerTotals = observer(() => {
    const { timerStore } = React.useContext(RootStoreContext);
    const { t } = useTranslation(['timers', 'common']);
    const [, setTick] = useState(0);
    const { stepSelectedDate, currentDate } = timerStore;
    const currentDateString = currentDate.toLocaleDateString();
    const isToday = currentDateString === new Date().toLocaleDateString();
    const { total, draft, posted, unsubmitted, billable, nonBillable } = timerStore.getTodayDurations();

    useEffect(() => {
        const interval = setInterval(() => {
            if (timerStore.timers.some(timer => timer.active)) {
                setTick(tick => tick + 1);
            }
        }, 250);

        return () => clearInterval(interval);
    }, []);

    return (
        <Styled.DailyTimerHeader>
            <Styled.DailyTimerContainer>
                <IconButton
                    onClick={() => stepSelectedDate(-1)}
                    color="secondary"
                    aria-label={t('today_timer_header.action.navigate.previous')}
                >
                    <KeyboardArrowLeft/>
                </IconButton>
                <Styled.DailyTimer>{isToday ? t('today_timer_header.title') : currentDateString}</Styled.DailyTimer>
                <IconButton
                    onClick={() => stepSelectedDate(1)}
                    color="secondary"
                    aria-label={t('today_timer_header.action.navigate.next')}
                    disabled={isToday}
                >
                    <KeyboardArrowRight/>
                </IconButton>
            </Styled.DailyTimerContainer>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.total')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue>{total}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.draft')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue>{draft}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.posted')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue>{posted}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.unsubmitted')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue>{unsubmitted}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.billable')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue colorCode="billable">{billable}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
            <Styled.DailyTimerSection>
                <Styled.DailyTimerLabel>{t('today_timer_header.non_billable')}</Styled.DailyTimerLabel>
                <Styled.DailyTimerValue colorCode="nonBillable">{nonBillable}</Styled.DailyTimerValue>
            </Styled.DailyTimerSection>
        </Styled.DailyTimerHeader>
    );
});